import { createHashHistory } from 'history';
import store from '@/store';
import { setShowMenuMask, setTryOutDialog } from '@store/appSlice';

const history = createHashHistory();

history.listen(() => {
  store.dispatch(setShowMenuMask(false)); // 关闭菜单
  store.dispatch(setTryOutDialog(false)); // 关闭试用申请
});

export default history;
